import "./plotsExport.scss";
import { IVeriTableRow, IVeriTableHeader } from "@directives/_veri/veriTable/veriTable.component";
import { IPlot } from "@interfaces/IPlot";
import { ReasonCode } from "@enums/ReasonCode";
import { PlotService } from "@services/plot.service";
import { VeriDate } from "@services/veriDate.service";
import { SortType } from "@enums/SortType";
import { VeriTableService } from "@directives/_veri/veriTable/veriTable.service";
import { UnitConversionType } from "@services/unitConversion.service";
import { IVehicle } from "@interfaces/IVehicle";
import { TranslationService } from "@services/translation.service";
import { IDateFilter } from "@interfaces/filters/IDateFilter";
import { DateRange } from "@enums/DateRange.enum";

interface IComponentBindings {
    plots: IPlot[];
    additionalData: IVehicle;
}

class ComponentController implements angular.IComponentController, IComponentBindings {
    tableRows: IVeriTableRow<any>[] = [];
    tableHeaders: IVeriTableHeader[] = [
        { title: this.translationService.t("plotsExport.time"), sortType: SortType.Date },
        { title: this.translationService.t("plotsExport.speed") },
        { title: this.translationService.t("plotsExport.direction") },
        { title: this.translationService.t("plotsExport.reason") },
        { title: this.translationService.t("plotsExport.odometer") },
        { title: this.translationService.t("plotsExport.location") }
    ];

    plots: IPlot[];
    additionalData: IVehicle;

    defaultDateRange: DateRange = DateRange.Today;
    dateFilter: IDateFilter;

    exportTitle = this.translationService.t("plotsExport.plots");

    static $inject = ["plotService", "veriDate", "veriTableService", "translationService"];

    constructor(
        private readonly plotService: PlotService,
        private readonly veriDate: VeriDate,
        private readonly veriTableService: VeriTableService,
        private readonly translationService: TranslationService) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        this.dateFilter = this.veriDate.dateRangeFromEnum(this.defaultDateRange);

        this.updatePlotsTable();
    }



    onDateFilterChanged(filter: IDateFilter): void {
        this.dateFilter = filter;
        this.updatePlotsTable();
    }

    private updatePlotsTable() {

        this.tableRows = [];

        if (this.plots) {
            this.tableRows = this.createExportDataFromJourneyPlots(this.plots);
        }

        if (this.additionalData) {
            this.exportTitle = this.translationService.t('plotsExport.vehiclePlots', this.additionalData.ShortReg);
        }
    }
    private createExportDataFromJourneyPlots(plots: IPlot[]): IVeriTableRow<any>[] {

        let startTimeMinutes = this.veriDate.parseTimeSpan(this.dateFilter.startTime??"00:00:00") / 60;
        let endTimeMinutes = this.veriDate.parseTimeSpan(this.dateFilter.endTime ?? "23:59:59") / 60;

        return this.veriTableService.createTableRowsWithCells(plots.filter(p => {
            let plotTimeMinutes = this.veriDate.getMinuteOfDayFromDate(this.veriDate.createDate(p.Utc));
            return plotTimeMinutes >= startTimeMinutes && plotTimeMinutes <= endTimeMinutes
        }),
            (plot) => {
                const odometerKm = plot.Odometer / 1000;
                return [
                    this.veriTableService.createDateTimeCell(plot.Utc),
                    this.veriTableService.createConvertedValueCell(plot.Velocity, UnitConversionType.Speed),
                    { contents: this.plotService.convertDirectionToWords(plot.Direction) },
                    { contents: ReasonCode[plot.Reason] },
                    this.veriTableService.createConvertedValueCell(odometerKm, UnitConversionType.Distance),
                    this.veriTableService.createLocationInformationCell(plot.Id, "row.data", plot)
                ];
            },
            (plot) => {
                return `${this.veriDate.formatDate(plot.Utc)}${this.plotService.convertDirectionToWords(plot.Direction)}${ReasonCode[plot.Reason]}${plot?.LocationInformation?.LocationDescription}`;
            });
    }
}

export class PlotsExportComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            plots: "<",
            additionalData: "<?"
        };

        this.controller = ComponentController;
        this.template = require("./plotsExport.html");
    }
}
